<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <cuenta-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import CuentaProvider from "../../../../providers/CuentaProvider";
    
    import {CrudUpdate, ClientError} from '@dracul/common-frontend'
    
    import CuentaForm from "../CuentaForm";
  
    

    export default {
        name: "CuentaUpdate",
        
        components: { CuentaForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'cobrox.cuenta.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                id: this.item.id,
                form: {
                    nombre: this.item.nombre,
                    numero: this.item.numero
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    CuentaProvider.updateCuenta(this.id, this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.updateCuenta)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

